import BackendDeveloperPage from "./BackendDeveloperPage";

export default function GolangDeveloperPage() {
  return <BackendDeveloperPage technology="golang" />;
}
